export default __webpack_public_path__ + "static/media/24.4b631ad0.jpg";